<div class="cowing-tag" [ngStyle]="{'background': background, 'color': color }">
  {{text}}
</div>